import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { RoleAssignment } from 'se-resource-types/lib/UserService'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root'
})
export class RoleAssignmentService {
  public endpoint = 'role_assignments'

  constructor(
    private api: UserServiceApiService
  ) {
    // noop
  }

  public grantTopDownOrgAccess(resourceId: number, principalId: number): Observable<RoleAssignment> {
    const body = {
      org_id: resourceId,
      principal_id: principalId,
      resource_id: resourceId,
      resource_type: 'Organization',
      principal_type: 'Organization',
      role_type: 'SimpleRole',
      role_id: 76
    }
    return this.api.post<RoleAssignment>(this.endpoint, body).pipe(
      map(response => response.result)
    )
  }

  public getTopDownOrgAccessRoles(resourceId: number): Observable<RoleAssignment[]> {
    const params = {
      resource_type: 'Organization',
      principal_type: 'Organization',
      role: 'top_down_org_access',
      resource_id: resourceId
    }
    return this.api.get<RoleAssignment[]>(this.endpoint, { params }).pipe(
      map(response => response.result)
    )
  }

  public deleteRole(roleId: number): Observable<any> {
    return this.api.delete(`${this.endpoint}/${roleId}`)
  }

}
